var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCreateTemplateIcon = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 14,
  fill: "none",
  viewBox: "0 0 16 14",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  d: "M10.667 13v-1.333A2.666 2.666 0 0 0 8 9H3.333a2.667 2.667 0 0 0-2.666 2.667V13m10.666-6.667 1.333 1.334L15.333 5m-7-1.333a2.667 2.667 0 1 1-5.333 0 2.667 2.667 0 0 1 5.333 0Z"
})));
export { SvgCreateTemplateIcon as ReactComponent };
export default __webpack_public_path__ + "assets/images/createTemplateIcon.svg";